import { IActivity, IApiActivity } from '../../interface/IActivity'

export const transformActivity = (apiActivity: IApiActivity): IActivity => {
  return {
    categoryId: apiActivity.attributes.category_id,
    color: apiActivity.attributes.color,
    image: apiActivity.attributes.image,
    id: apiActivity.id,
    name: apiActivity.attributes.name,
    uuid: apiActivity.attributes.uuid,
    duration: apiActivity.attributes.duration,
  }
}
